import React from "react";
import { NavLink } from "react-router-dom";
import {
  Table,
  Tag,
  Space,
  Breadcrumb,
  Select,
  DatePicker,
  Row,
  Col,
} from "antd";
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const { RangePicker } = DatePicker;
function ComponentsDetails() {
  const data = [
    {
      stage: "1",
      process: "Cutting",
      vendor: "AKS",
      closingStock: "400 units",
      receivedStock: "200 units",
      readyStock: "100 units",
      dispatchQty: "100 units",
      dispatchStatus: "Vehicle Assigned",
    },
    {
      stage: "2",
      process: "Hobbing",
      vendor: "SV",
      closingStock: "400 units",
      receivedStock: "200 units",
      readyStock: "100 units",
      dispatchQty: "100 units",
      dispatchStatus: "No Request",
    },
    {
      stage: "3",
      process: "Welding",
      vendor: "NV",
      closingStock: "400 units",
      receivedStock: "200 units",
      readyStock: "100 units",
      dispatchQty: "100 units",
      dispatchStatus: "No Request",
    },
  ];
  function onChange(value) {
    console.log(`selected ${value}`);
  }

  function onBlur() {
    console.log("blur");
  }

  function onFocus() {
    console.log("focus");
  }

  function onSearch(val) {
    console.log("search:", val);
  }
  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Inventory</Breadcrumb.Item>
        <Breadcrumb.Item>Component Data</Breadcrumb.Item>
        <Breadcrumb.Item>IC201</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <h2 className="titles">
          IC201 INVENTORY <span>DATA</span>
        </h2>
        <Row>
          <Col xs={12} xl={8}>
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select Vendor"
              optionFilterProp="children"
              onChange={onChange}
              onFocus={onFocus}
              onBlur={onBlur}
              onSearch={onSearch}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="AKS Enterprises">AKS Enterprises</Option>
              <Option value="SV Enterprises">SV Enterprises</Option>
              <Option value="ACM Pvt Ltd">ACM Pvt Ltd</Option>
            </Select>
          </Col>
          <Col xs={12} xl={8}>
            <RangePicker />
          </Col>
        </Row>
        <Space></Space>
        <br />
        <Row>
          <Col xs={12} xl={6}>
            <div className="DetailCard">
              <p>Closing Stock</p>
              <h3>300</h3>
              <span>&nbsp;</span>
            </div>
          </Col>
          <Col xs={12} xl={6}>
            <div className="DetailCard">
              <p>Total (Received + Ready)</p>
              <h3>1800</h3>
              <span>Sum Total of Received and Ready</span>
            </div>
          </Col>
          <Col xs={12} xl={6}>
            <div className="DetailCard">
              <p>FG</p>
              <h3>0</h3>
              <span>Sum Total of Received and Ready</span>
            </div>
          </Col>
          <Col xs={12} xl={6}>
            <div className="DetailCard">
              <p>Delivered</p>
              <h3>0</h3>
              <span>Delivered to client</span>
            </div>
          </Col>
        </Row>
        <br />
        <Table dataSource={data}>
          <Column title="Stage" dataIndex="stage" key="stage" />
          <Column title="Process" dataIndex="process" key="process" />
          <Column title="Vendor" dataIndex="vendor" key="vendor" />
          <Column
            title="Closing Stock"
            dataIndex="closingStock"
            key="closingStock"
          />
          <Column
            title="Received"
            dataIndex="receivedStock"
            key="receivedStock"
          />
          <Column title="Ready" dataIndex="readyStock" key="readyStock" />
          <Column
            title="Dispatch Qty."
            dataIndex="dispatchQty"
            key="dispatchQty"
          />
          <Column
            title="Dispatch Status"
            dataIndex="dispatchStatus"
            key="dispatchStatus"
          />
        </Table>
      </div>
    </div>
  );
}

export default ComponentsDetails;
